import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// komodo SellPriceController (api/sellprice): price lists (gy_sellpricemain) with their rules.
const enc = encodeURIComponent;

// SellPriceQC: { priceApplyName: 'Normal' | 'Promotion', pricelistName, priceCode, deptCode, searchText … }
const queryPager = (query) =>
	Client.post('/api/sellprice/query-pager', {
		...PAGE_ALL,
		...(query || {}),
	}).then(pagerRows);
const get = (priceID) => Client.get(`/api/sellprice/${enc(priceID)}`);
// → SaveBillOperationResult { billId, billNumberCode }
const create = (dto) => Client.post('/api/sellprice', dto);
const update = (priceID, dto) =>
	Client.put(`/api/sellprice/${enc(priceID)}`, dto);
// SellPriceMaintainer changes StopFlag only through this action (Update keeps the stored flag).
const setArchived = (priceID, archived) =>
	Client.put(`/api/sellprice/archive/${enc(priceID)}`, {
		archived: !!archived,
	});
const setValid = (priceID, invalid) =>
	Client.put(`/api/sellprice/valid/${enc(priceID)}`, { invalid });

// komodo has no DELETE for price lists: a list is retired with the "invalid" (StopFlag) switch, like Blazor.
export default { queryPager, get, create, update, setArchived, setValid };
